import React from 'react';
import DataVendorForm from "../../../components/data_vendors/DataVendorForm";
import { useHistory, useParams } from 'react-router';
import {useTranslation} from "react-i18next";
import { useGetDataVendorQuery, useGetDataVendorReferencesQuery, useUpdateDataVendorMutation } from '../../../api/dataVendorApiSlice';

function DataVendorsEdit(props) {
  const { t } = useTranslation();
  const { dataVendorKey } = useParams();
  const {data: formRefValues } = useGetDataVendorReferencesQuery();
  const {
    data: dataVendor,
    isSuccess,
  } = useGetDataVendorQuery(dataVendorKey)
  const history = useHistory();
  const [updateDataVendor, { isLoading: isUpdating }] = useUpdateDataVendorMutation(dataVendorKey)
  const onSubmit = (data) => {
    updateDataVendor({slug: dataVendorKey, ...data}).unwrap()
      .then(payload => {
        history.push(`/data_vendors/${payload.slug}`);
      })
      .catch(error => {})
  }

  const handleCancel = () => history.push(`/data_vendors/${dataVendorKey}`)

  return (
    <>
      { isSuccess &&
        <DataVendorForm
          mainTitle={t("menu.data_vendors")}
          subTitle={dataVendor?.name}
          formRefValues={formRefValues}
          onSubmit={onSubmit}
          dataVendor={dataVendor}
          onCancel={handleCancel}
        />
      }
    </>
  )
}

export default DataVendorsEdit
